import { ViewStyle } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';

export interface BasePressTooltipProps {
  TooltipButton: ({
    onPress,
    testID,
    isContentVisible,
  }: {
    onPress: () => void;
    testID: string;
    isContentVisible: boolean;
  }) => React.JSX.Element;
  TooltipContent: ({ onClose }: { onClose: () => void }) => React.JSX.Element;
  containerStyle?: ViewStyle;
  backgroundColor?: string;
  width?: number;
  height?: number;
  position?: TooltipPosition;
  onPress?: () => void;
  tooltipID: TestIDs | string;
  showTooltipArrow?: boolean;
  arrowSize?: number;
  arrowPosition?: number;
  minDistanceFromEdge?: number;
}

export enum TooltipPosition {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT,
}
